const RoutingPaths = {
  GENERATE: 'generate',
  SECTION_PARAM: ':sectionID',
  SHL_PARAM: ':shl',
  VIEWER: 'shlink:',
};

export default RoutingPaths;
